import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
//components
import Pagination from './Pagination';
import NoResults from './NoResults';
import PaginationLoader from 'components/loader/PaginationLoader';

const FilteredResults = ({ children, noResults, page, totalPages, changePage, isLoading, data }) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <PaginationLoader visibility={isLoading} />
        </div>
      );
    }

    if (noResults) {
      return <NoResults className='noFavorites' />;
    }

    return children;
  };

  const shouldShowPagination = page && totalPages && !isLoading;

  return (
    <>
      <Row className="mx-2">{renderContent()}</Row>
      {shouldShowPagination && (
        <Pagination changePage={changePage} page={page} totalPages={totalPages} />
      )}
    </>
  );
};

FilteredResults.propTypes = {
  children: PropTypes.any,
  data: PropTypes.bool.isRequired,
  noResults: PropTypes.bool,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default FilteredResults;
